import React, { memo } from "react";
import { FlexBox, RectangularColorBox } from "../../../Components";
import styles from "./OrderMatrixRow.module.scss";
import { Ean } from "./Ean";

const IncrementDecrementRowContainer = ({ children }) => (
  <FlexBox className={styles.incrementDecrementRowContainerAbsolute}>
    {children}
  </FlexBox>
);

const ColorColumn = ({ color }) => (
  <IncrementDecrementRowContainer>
    <RectangularColorBox color={color.hex} label={color.code} />
  </IncrementDecrementRowContainer>
);

const Sizes = ({
  product,
  sizes,
  length,
  color,
  onChange,
  getValue,
  isReadonly,
  deliveryDate,
  number,
  season,
}) => (
  <FlexBox className={[styles.columnContainer, "eanrow"].join(" ")}>
    {sizes.map((s) => (
      <Ean
        product={product}
        key={`${length}-${color.code}-${s}`}
        isReadonly={isReadonly}
        onChange={onChange}
        getValue={getValue}
        length={length}
        color={color.code}
        size={s}
        deliveryDate={deliveryDate}
        number={number}
        season={season}
      />
    ))}
  </FlexBox>
);

export const OrderMatrixRow = ({
  color,
  length,
  sizes,
  product,
  valueForSizeAndColor,
  updateValueForColorAndSize,
  isReadonly,
  deliveryDate,
  number,
  season,
}) => (
  <FlexBox className={styles.orderMatrixRowContainer} flex={1}>
    <ColorColumn color={color} />
    <Sizes
      isReadonly={isReadonly}
      product={product}
      sizes={sizes}
      color={color}
      length={length}
      onChange={updateValueForColorAndSize}
      getValue={valueForSizeAndColor}
      deliveryDate={deliveryDate}
      number={number}
      season={season}
    />
  </FlexBox>
);

export default memo(OrderMatrixRow);
